var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPmCash = function SvgPmCash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 6.75,
    width: 32.5,
    height: 20.5,
    rx: 3.25,
    fill: "#CCEEDC",
    stroke: "#4DC484",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 23.75a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5Z",
    stroke: "#4DC484",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1 14.75a1.5 1.5 0 0 0-1.35-.75h-1.5a1.5 1.5 0 0 0 0 3h1.5a1.5 1.5 0 0 1 0 3h-1.5a1.5 1.5 0 0 1-1.35-.75M17 20v1.5m0-9V14v-1.5Z",
    stroke: "#4DC484",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPmCash;